import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class CoinPusherGameImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /coin-pusher-game/config */
  public getCoinPusherGameConfig(query: { tokenAddress: string; userAddress: string }) {
    return this.makeRequest<API.CoinPusherConfigSchema>(`coin-pusher-game/config`, {
      method: 'GET',
      query
    });
  }

  /** GET /coin-pusher-game/stats */
  public getCoinPusherGameStats(query: { tokenAddress: string }) {
    return this.makeRequest<API.CoinPusherStatsByTokenResponseSchema>(`coin-pusher-game/stats`, {
      method: 'GET',
      query
    });
  }

  /** GET /coin-pusher-game/users-stats */
  public getCoinPusherGameUsersStats(query: {
    tokenAddress?: string;
    userAddress?: string;
    onlyWinners?: string; // boolean
    limit?: string; // number
    offset?: string; // number
  }) {
    return this.makeRequest<API.CoinPusherUsersStatisticsResponseSchema>(`coin-pusher-game/users-stats`, {
      method: 'GET',
      query
    });
  }

  /** GET /coin-pusher-game/result */
  public getCoinPusherGameResult(query: { transactionHash: string }) {
    return this.makeRequest<API.CoinPusherGameByTransactionHashResponseSchema>(`coin-pusher-game/result`, {
      method: 'GET',
      query
    });
  }
}
